/**
 * Compact "My Holiday" card — designed to sit beside "Storage used this month"
 * in the lower Dashboard area. Same height/padding/border style as the storage
 * card so the two line up on desktop and stack cleanly on mobile.
 *
 * Deliberately does NOT surface manager approvals here — those are operational
 * and live in the Leave & Holidays / Approvals area, not on a personal card.
 */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Umbrella, ChevronRight } from "lucide-react";
import api from "@/lib/api";

const fmt = (n) => Number(n || 0).toLocaleString(undefined, { maximumFractionDigits: 2 });

export default function DashboardHolidayWidget() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/leave/dashboard-widget").then((r) => setData(r.data)).catch(() => setData(null));
  }, []);
  if (!data) return null;
  const unit = data.unit === "hours" ? "Hours" : "Days";
  return (
    <section className="bg-white border border-slate-200 p-4 flex items-center gap-4 h-full" data-testid="dashboard-holiday-widget">
      <div className="w-10 h-10 border border-slate-200 text-amber-600 flex items-center justify-center shrink-0">
        <Umbrella className="w-5 h-5" strokeWidth={1.75} />
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-[10px] uppercase tracking-widest text-slate-500 font-semibold">My Holiday</div>
        <div className="font-heading text-lg font-semibold tabular-nums" data-testid="widget-available">
          {fmt(data.available)} {unit} Available
        </div>
        <div className="text-[11px] text-slate-500">
          <span data-testid="widget-taken">{fmt(data.taken)} Taken</span>
          <span className="mx-1 text-slate-300">·</span>
          <span data-testid="widget-booked">{fmt(data.booked)} Booked</span>
          <span className="mx-1 text-slate-300">·</span>
          <span className={data.pending > 0 ? "text-amber-700" : ""} data-testid="widget-pending">{fmt(data.pending)} Pending</span>
        </div>
      </div>
      <Link to="/time-off-requests" className="text-xs text-sky-700 hover:underline inline-flex items-center gap-0.5 shrink-0" data-testid="widget-view-link">
        View Leave <ChevronRight className="w-3 h-3" />
      </Link>
    </section>
  );
}
